import { useCallback, useEffect, useRef, useState } from 'react';
import resizeEvent, { unbind } from 'element-resize-event';
export function useRootSize(params) {
    var _a = useState({ width: 0, height: 0 }), size = _a[0], setSize = _a[1];
    var internalRef = useRef(null);
    var ref = (params === null || params === void 0 ? void 0 : params.ref) || internalRef;
    var measure = useCallback(function () {
        var _a;
        var rect = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!rect) {
            return;
        }
        if (size.width !== rect.width || size.height !== rect.height) {
            setSize({
                width: rect.width,
                height: rect.height
            });
        }
    }, [ref, size]);
    useEffect(function () {
        measure();
    }, []);
    useEffect(function () {
        if (ref.current) {
            resizeEvent(ref.current, measure);
        }
        return function () {
            if (ref.current) {
                unbind(ref.current, measure);
            }
        };
    }, []);
    return {
        ref: ref,
        size: size
    };
}
//# sourceMappingURL=useRootSize.js.map